import React from 'react';
import {Link} from 'react-router-dom';
import {Icon} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

interface DatabaseInfoMessageProps {
}

const DatabaseInfoMessage = ({}: DatabaseInfoMessageProps) => {
  return (
    <div className="share-report__popover__database-note">
      <Icon icon={IconNames.INFO_SIGN}/>&nbsp;
        <span>
          Share underlying <Link to="/d/d">database</Link> connections with workspace
          or users in order for them to view and query SQL data.
        </span>
    </div>
  );
}

export default DatabaseInfoMessage;
